<template>
	<layout-admin>
		<div class="pb-18 divide-y-2 divide-gray-200">
			<ui-alert
				v-if="success"
				type="success"
				message="Your inputs have been saved!"
			/>
			<ui-alert
				v-else-if="hasErrors"
				type="error"
				message="Your input could not be saved!"
			/>
		</div>

		<h1 class="text-3xl font-semibold text-gray-900 mb-4 pl-4">
			{{ __("Auction Bid") }} #{{ bid.id }}
		</h1>

		<div class="pl-4 text-xl">
			Käufer: {{ bid.buyer.company_name }} <br />
			Verkäufer: {{ bid.seller.company_name }}<br />
		</div>
		<bid-edit-step-1-auction
			:bid="bid"
			:form="form"
			:offer="offer"
			:show-reference="false"
			:active-futures="activeFutures"
			:bidValidityTime="bidValidityTime"
			:can-remove-bid="false"
			v-on:tryGotoStepIfFormValid="submitForm"
		/>
	</layout-admin>
</template>

<script>
function padTo2Digits(num) {
	return num.toString().padStart(2, "0");
}

export default {
	props: {
		bid: {
			type: Object,
			required: true,
		},
		offer: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		success: {
			type: Boolean,
			default: null,
		},
		auction: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			adminUser: this.$inertia.page.props.user,
			form: Vue.observable(
				this.$inertia.form(JSON.parse(JSON.stringify(this.bid)))
			),
			submitButtonDisabled: false,
		};
	},
	methods: {
		async submitForm() {
			let endpoint = this.$page.url,
				method = "patch",
				that = this;

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
			});
		},
		async handleSubmit() {
			console.log("HANDLING", this.form);
		},
	},
	computed: {
		hasErrors() {
			return Object.keys(this.form.errors ?? {}).length > 0;
		},
		bidValidityTime() {
			var date = new Date(this.auction.bidding_ends_at);
			date.setMinutes(date.getMinutes() + 30); // valid until 30 minutes after bidding ends
			return (
				padTo2Digits(date.getHours()) + ":" + padTo2Digits(date.getMinutes())
			);
		},
	},
};
</script>
